//Remove some value for rating sort
const observer = new MutationObserver((mutations) => {
  const dropdown = document.querySelector('.jdgm-sort-dropdown');
  
  if (dropdown && !dropdown.dataset.filtered) {
    const keep = ['most-recent', 'highest-rating', 'lowest-rating'];
    
    [...dropdown.options].forEach(opt => {
      if (!keep.includes(opt.value)) {
        opt.remove();
      }
    });
    
    dropdown.dataset.filtered = 'true';
    
    // observer.disconnect();
  }
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});





// Fix review for loadmore
(function() {
  let reinitTimeout;
  
  function reinitJudgeMe() {
    clearTimeout(reinitTimeout);
    reinitTimeout = setTimeout(() => {
      if (typeof window.jdgm !== 'undefined') {
        // Method 1: Customize badges
        if (window.jdgm.customizeBadges) {
          window.jdgm.customizeBadges();
        }
        
        // Method 2: Re-initialize widgets
        if (window.JudgeMe && window.JudgeMe.widgets) {
          window.JudgeMe.widgets.forEach(widget => {
            if (widget.init) widget.init();
          });
        }
        
      }
    }, 300);
  }
  
  // 1. Init when DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', reinitJudgeMe);
  } else {
    reinitJudgeMe();
  }
  
  // 2. Listen Shopify theme events
  document.addEventListener('shopify:section:load', reinitJudgeMe);
  document.addEventListener('shopify:section:reorder', reinitJudgeMe);
  
  // 3. Listen custom events
  document.addEventListener('theme:product:loaded', reinitJudgeMe);
  document.addEventListener('collection:products:loaded', reinitJudgeMe);
  
  // 4. Observer for load more
  const observer = new MutationObserver((mutations) => {
    let shouldReinit = false;
    
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) {
          if (node.classList?.contains('jdgm-widget') || 
              node.querySelector?.('.jdgm-widget')) {
            shouldReinit = true;
          }
        }
      });
    });
    
    if (shouldReinit) {
      reinitJudgeMe();
    }
  });
  
  const containers = [
    '.product-grid',
    '.collection-grid', 
    '[data-collection-container]',
    '.product-list',
    '[data-products]'
  ];
  
  containers.forEach(selector => {
    const container = document.querySelector(selector);
    if (container) {
      observer.observe(container, {
        childList: true,
        subtree: true
      });
    }
  });
  
  // 5. Intercept AJAX calls
  const originalFetch = window.fetch;
  window.fetch = function(...args) {
    return originalFetch.apply(this, args).then(response => {
      if (response.url.includes('/collections/') || 
          response.url.includes('/products/')) {
        reinitJudgeMe();
      }
      return response;
    });
  };
  
})();
